/**
 * Labstep
 *
 * @module components/PurchaseOrder/Form/ShowEdit/TaxRate
 * @desc ShowEdit form for order request currency and handling
 */

import { fieldPurchaseOrderTaxRate } from 'labstep-web/components/PurchaseOrder/Form/fields';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import type React from 'react';
import type { IPurchaseOrderFormShowEditTaxRateProps } from './types';

export const PurchaseOrderFormShowEditTaxRate: React.FC<
  IPurchaseOrderFormShowEditTaxRateProps
> = ({ purchaseOrder }) => (
  <ShowEditText
    entity={purchaseOrder}
    entityName={purchaseOrder.entityName}
    field={fieldPurchaseOrderTaxRate}
  >
    {purchaseOrder.printVat}
  </ShowEditText>
);
